import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PrinterTarget, PrinterTargetRole } from 'src/typings';

type ThermalTargetOption = PrinterTarget & {
  targetId: string;
  label: string;
  role: PrinterTargetRole;
  status: 'online' | 'offline';
};

export type ThermalPrintTargetDialogData = {
  currentTargetId?: string;
  options: ThermalTargetOption[];
  role: PrinterTargetRole;
  title: string;
  description: string;
  makeDefaultLabel: string;
  fieldLabel?: string;
  cancelLabel?: string;
  submitLabel?: string;
};

export type ThermalPrintTargetDialogResult = {
  targetId: string;
  makeDefault: boolean;
};

@Component({
  selector: 'app-thermal-print-target-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>

    <mat-dialog-content class="dialog-content">
      <p class="dialog-text">{{ data.description }}</p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ data.fieldLabel || (data.role === 'label' ? 'Принтер этикеток' : 'Принтер чеков') }}</mat-label>
        <mat-select [(value)]="selectedTargetId">
          <mat-option *ngFor="let option of data.options" [value]="option.targetId">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox [(ngModel)]="makeDefault">{{ data.makeDefaultLabel }}</mat-checkbox>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="close()">{{ data.cancelLabel || 'Отмена' }}</button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="submit()"
        [disabled]="!selectedTargetId"
      >
        {{ data.submitLabel || 'Использовать выбранный' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .dialog-content {
        min-width: 360px;
        display: grid;
        gap: 12px;
      }

      .dialog-text {
        margin: 0;
      }

      .full-width {
        width: 100%;
      }
    `
  ]
})
export class ThermalPrintTargetDialogComponent {
  selectedTargetId = this.data.currentTargetId || this.data.options[0]?.targetId || '';
  makeDefault = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ThermalPrintTargetDialogData,
    private readonly dialogRef: MatDialogRef<
      ThermalPrintTargetDialogComponent,
      ThermalPrintTargetDialogResult | undefined
    >
  ) {}

  close() {
    this.dialogRef.close();
  }

  submit() {
    if (!this.selectedTargetId) {
      return;
    }

    this.dialogRef.close({
      targetId: this.selectedTargetId,
      makeDefault: this.makeDefault
    });
  }
}
